import {Clients,EnvironmentEnum,GoogleApiKey,GoogleCaptchaKey,Icons,Loader,Logo,ServerUrl} from "./clients";

export const environment = {
  production: false,
  login: Clients.VERHEYEN,
  environment: EnvironmentEnum.VERHEYEN_TEST,
  logo: Logo.VERHEYEN,
  loader: Loader.VERHEYEN,
  icons: Icons.VERHEYEN,
  serverUrl: ServerUrl.VERHEYEN_TEST,
  googleApiKey: GoogleApiKey.VERHEYEN_TEST,
  googleCaptchaKey: GoogleCaptchaKey.VERHEYEN_TEST,
  spotEnabled: true,
  claimEnabled: false,
  blockchainEnabled: true
  };
  